module.exports = __webpack_public_path__ + "static/media/todd.2a8cbd7f.png";